var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-benefits",class:{ container: _vm.$store.state.layout === 'mobile' }},_vm._l((_vm.benefits),function(b,i){return _c('p',{key:i,staticClass:"benefit"},[_c('IconCheckBenefits'),_vm._v("\n    "+_vm._s(b)+"\n  ")],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }